import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ClipMetadataService from '../services/clipMetadataService';
import ViralClipsMetadata from '../components/ViralClipsMetadata';
import './css/ViralClipsMetadataPage.css';

const ViralClipsMetadataPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clipsData, setClipsData] = useState(null);
  const [allMetadataFiles, setAllMetadataFiles] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(jobId || '');

  // Fetch the viral clips metadata for the specified job
  useEffect(() => {
    const fetchMetadata = async () => {
      if (!jobId) {
        // If no jobId is provided, just fetch the list of available metadata files
        try {
          const metadata = await ClipMetadataService.getAllViralClipsMetadata();
          setAllMetadataFiles(metadata.files || []);
          setLoading(false);
        } catch (err) {
          setError(err.message);
          setLoading(false);
        }
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        // Fetch the viral clips metadata for the job
        const metadata = await ClipMetadataService.getViralClipsMetadata(jobId);
        
        // Update the state with the fetched data
        setClipsData(metadata);
        
        // Also fetch the list of all available metadata files
        const allMetadata = await ClipMetadataService.getAllViralClipsMetadata();
        setAllMetadataFiles(allMetadata.files || []);
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [jobId]);

  // Handle job selection
  const handleJobSelect = (e) => {
    const newJobId = e.target.value;
    setSelectedJobId(newJobId);
    
    if (newJobId) {
      navigate(`/viral-clips-metadata/${newJobId}`);
    } else {
      navigate('/viral-clips-metadata');
    }
  };

  return (
    <div className="viral-clips-metadata-page">
      <div className="page-header">
        <h1>Viral Clips Metadata</h1>
        
        <div className="job-selector">
          <label htmlFor="job-select">Select Job:</label>
          <select 
            id="job-select" 
            value={selectedJobId} 
            onChange={handleJobSelect}
          >
            <option value="">-- Select a job --</option>
            {allMetadataFiles.map((file) => {
              // Extract job ID from filename (assuming format: jobId.json)
              const jobId = file.replace('.json', '');
              return (
                <option key={file} value={jobId}>
                  {jobId}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loader"></div>
          <p>Loading viral clips metadata...</p>
        </div>
      ) : error ? (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button 
            className="retry-button"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      ) : clipsData ? (
        <ViralClipsMetadata clipsData={clipsData} />
      ) : (
        <div className="no-job-selected">
          <p>Please select a job to view its viral clips metadata.</p>
        </div>
      )}
    </div>
  );
};

export default ViralClipsMetadataPage; 